import { render } from "./EmpresaContactos.vue?vue&type=template&id=042f8f76&scoped=true"
import script from "./EmpresaContactos.vue?vue&type=script&lang=js"
export * from "./EmpresaContactos.vue?vue&type=script&lang=js"

import "./EmpresaContactos.vue?vue&type=style&index=0&id=042f8f76&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-042f8f76"

export default script